import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";

const ProjectModal = ({ project, onClose }) => {
  return (
    <AnimatePresence>
      <motion.div
        className="modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="modal-content"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="modal-close" onClick={onClose}>
            <FaTimes />
          </button>

          <div className="modal-header">
            <h2>{project.title}</h2>
            <p className="modal-subtitle">{project.subtitle}</p>
          </div>

          <div className="modal-body">
            <div
              className="modal-image"
              style={{
                // backgroundImage: `url(https://via.placeholder.com/800x500?text=${project.title.replace(
                //   /\s+/g,
                //   "+"
                // )})`,
                backgroundImage: `url(https://placehold.co/800x500/2a3d66/FFF?text=${encodeURIComponent(
                  project?.title
                )}`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            ></div>

            <div className="modal-section">
              <h3>Project Description</h3>
              <div className="modal-description">
                {project.detailedDescription.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>

            <div className="modal-section">
              <h3>Technologies Used</h3>
              <div className="modal-tech">
                {project.technologies.map((tech, index) => (
                  <span key={index}>{tech}</span>
                ))}
              </div>
            </div>

            {project.subProjects && project.subProjects.length > 0 && (
              <div className="modal-section">
                <h3>Related Projects</h3>
                <div className="modal-subprojects">
                  {project.subProjects.map((subProject, index) => (
                    <div key={index} className="subproject">
                      <h4>{subProject.title}</h4>
                      <p>{subProject.description}</p>
                      <div className="subproject-tech">
                        {subProject.technologies.map((tech, i) => (
                          <span key={i}>{tech}</span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ProjectModal;
